import { useEffect, useRef, useState } from "react";

//api
import { KBService } from "../../../service/kb-service";

//components
import { Toast } from 'primereact/toast'; 
import { Dialog } from "primereact/dialog";
import ReactMarkdown from 'react-markdown';

const ElaborationKB = ()=>{
    const [kbFiles,setkbFiles] = useState(null);
    const [markdownContentKB, setMarkdownContentKB] = useState('');
    const [previewVisibleKB, setPreviewVisibleKB] = useState(false);
    const [selectedFileForPreviewKB, setSelectedFileForPreviewKB] = useState(null);
    const [imageUrlForPreviewKB, setImageUrlForPreviewKB] = useState(null);
    const toast = useRef(null);

    // GET per i file KB
    useEffect(()=>{
        const fetchKB = ()=>{
            KBService.getAllKBFiles(
                (data)=>{
                    if(data && Array.isArray(data.results)){
                        setkbFiles(data.results)
                    } else {
                        const errorMessage = "La risposta non contiene un array valido di file.";
                        console.error(errorMessage);
                    }
                },
                (error)=>{
                    console.error('Errore durante il recupero dei file: ', error);
                }
            )
        };
        fetchKB();
    },[])

    //anteprima .md,.pdf,.txt,.jpeg,.jpg,.png file KB
    const handlePreviewKB = (file) => {
        if (file) {
            if (file.file_type === 'pdf') {
                console.log('Attempting to download PDF with ID:', file.id);
                KBService.downloadKBFile(
                    file.id, 
                    (blob) => {
                        const url = window.URL.createObjectURL(new Blob([blob]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', file.file_name || 'preview.pdf');
                        document.body.appendChild(link);
                        link.click();
                        link.parentNode.removeChild(link);
                        window.URL.revokeObjectURL(url);
                    },
                    (error) => {
                        console.error('Errore durante il download del PDF:', error);
                        toast.current.show({ severity: 'error', summary: 'Errore', detail: 'Impossibile scaricare il PDF.' });
                    }
                );
            } else if (file.file_type === 'txt' || file.file_type === 'text' || file.file_type === 'md')  {
                const token = localStorage.getItem('token');
                if (token) {
                    KBService.fetchMarkdownContent(
                        file.id, 
                        token,
                        setMarkdownContentKB
                    );
                    setSelectedFileForPreviewKB(file);
                    setPreviewVisibleKB(true);
                } else {
                    console.error('Token di autorizzazione non trovato.');
                    toast.current.show({ severity: 'warn', summary: 'Avviso', detail: 'Token di autorizzazione non trovato. Impossibile visualizzare l\'anteprima.' });
                }
            } else if (['jpeg', 'jpg', 'png'].includes(file.file_type)) {
                KBService.downloadKBFile(
                    file.id,
                    (blob) => {
                        const url = window.URL.createObjectURL(new Blob([blob], { type: `image/${file.file_type}` }));
                        setImageUrlForPreviewKB(url);
                        setSelectedFileForPreviewKB(file);
                        setPreviewVisibleKB(true);
                    },
                    (error) => {
                        console.error('Errore durante il download dell\'immagine:', error);
                        toast.current.show({ severity: 'error', summary: 'Errore', detail: 'Impossibile caricare l\'immagine per l\'anteprima.' });
                    }
                );
            } else {
                console.log('Anteprima non disponibile per questo tipo di file. Verrà avviato il download se supportato.');
                toast.current.show({ severity: 'info', summary: 'Info', detail: 'Anteprima non disponibile per questo tipo di file. Se supportato, verrà avviato il download.' });
            }
        } else {
          console.log('File non trovato per l\'anteprima.');
          toast.current.show({ severity: 'warn', summary: 'Avviso', detail: 'File non trovato per l\'anteprima.' });
        }
    };
    
    const hidePreviewDialogKB = () => {
        setPreviewVisibleKB(false);
        setMarkdownContentKB('');
        setSelectedFileForPreviewKB(null);
    };

    return (
        <div  className="elaborationDetail__ProjectWrapper">
            <Toast ref={toast} />
            {
                kbFiles ?
                kbFiles.map((file)=>(
                    <ul key={file.id}>
                        <div style={{display:'flex', flexDirection:'row'}}>
                            <li className="elaborationDetail__PreviewText" onClick={() => handlePreviewKB(file)}>{file.title}</li>
                        </div>
                    </ul>
                )):null
            }
            {selectedFileForPreviewKB && (
                <Dialog
                    header={`Anteprima ${selectedFileForPreviewKB.file_name}`}
                    visible={previewVisibleKB}
                    style={{ width: '80vw', height: '80vh' }}
                    onHide={hidePreviewDialogKB}
                    maximizable
                >
                {['txt', 'text', 'md'].includes(selectedFileForPreviewKB.file_type) ? (
                    <div
                        style={{
                            height: '100%',
                            overflowY: 'auto',
                            border: '1px solid #ccc',
                            padding: '10px',
                            backgroundColor: '#f9f9f9',
                        }}
                    >
                        <ReactMarkdown>{markdownContentKB}</ReactMarkdown>
                    </div>
                    ) : ['jpeg', 'jpg', 'png'].includes(selectedFileForPreviewKB.file_type) && imageUrlForPreviewKB ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <img 
                                src={imageUrlForPreviewKB} 
                                alt={`Anteprima di ${selectedFileForPreviewKB.file_name}`} 
                                style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} 
                            />
                        </div>
                        ) : (
                            <p>
                                Anteprima non disponibile per questo tipo di file.
                                Controlla nella cartella Download se il download è stato avviato.
                            </p>
                        )}
                </Dialog>
            )}
        </div>
    )
}

export default ElaborationKB